export default "__VITE_PUBLIC_ASSET__9b19241b__"